const DEBUG_CHART_SIZING = import.meta.env.DEV;
const MAX_EVENTS = 500;

export function recordChartSizingEvent(type, payload) {
  if (!DEBUG_CHART_SIZING || typeof window === "undefined") return;

  const event = {
    type,
    ts: Math.round(performance.now()),
    ...payload,
  };

  const buffer = window.__chartSizingDebugEvents || [];
  buffer.push(event);
  if (buffer.length > MAX_EVENTS) {
    buffer.splice(0, buffer.length - MAX_EVENTS);
  }
  window.__chartSizingDebugEvents = buffer;
}

export function createTaggedResizeEvent(reason) {
  const event = new Event("resize");
  event.__chartSizingReason = reason;
  return event;
}

export function dispatchChartSizingResize(reason) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(createTaggedResizeEvent(reason));
}
